
import * as React from 'react';
import { apiRequest } from '@/utils/request';

import { addSpacersToFeatures, ConditionsList, ExtraSection, FeatureList, getAllowedTransitions } from '../index';
import { CardGroup, ContentCard, Heading, Icon, Link, Text } from '@/components/ui';

export default function Plans ({ organization, currentPlan, plans }) {
    const allowedTransitions = getAllowedTransitions(currentPlan.slug)
    const canUpdate = WiseMetering.Permissions.hasRolePermissions('plans', 'update')
    const showEssentials = currentPlan.slug === 'free' && organization.type === 'building' && canUpdate

    const handleChangePlan = async (planSlug) => {
        const selectedPlan = WiseMetering.plans.find(t => t.get('slug') === planSlug)

        try {
            await apiRequest(`/organizations/${organization.id}/actions/change_plan`, 'PUT', { plan_id: selectedPlan.id })
            WiseMetering.layout.showTipper('success', i18next.t('plans.changed_successfully', { plan: selectedPlan.slug }))
            setTimeout(() => window.location.reload(), 1000)
        } catch (err) {
            WiseMetering.layout.showTipper('error', i18next.t('plans.contact_support'))
        }
    }

    const gridColumns = currentPlan.slug === 'free' ? (showEssentials ? 5 : 4) : currentPlan.slug === 'essentials' ? 4 : 3

    return (
        <>
            <Heading as="h2" variant="title-lg">{i18next.t('plans.wise_metering_subscription_plans')}</Heading>
            <div className="tw-h-6" />
            <CardGroup columns={gridColumns}>
                {plans.map((plan) => {
                    if (plan.slug === 'free' && currentPlan.slug !== 'free') {
                        return null
                    }

                    if (plan.slug === 'essentials' && currentPlan.slug !== 'essentials' && !showEssentials) {
                        return null
                    }

                    const isCurrent = currentPlan.slug === plan.slug
                    const primaryAction = canUpdate
                        ? isCurrent
                            ? { label: i18next.t('plans.current_plan'), disabled: true }
                            : allowedTransitions[plan.slug]
                                ? { label: `${i18next.t('plans.switch_to')} ${plan.key}`, onClick: () => handleChangePlan(plan.slug) }
                                : undefined
                        : undefined

                    return (
                        <div key={plan.key} className="tw-relative tw-h-full">
                            {isCurrent ? (
                                <div className="tw-pointer-events-none tw-absolute tw-right-6 tw-top-0">
                                    <Icon family="sharp" icon="bookmark" size="display" tone="primary" />
                                </div>
                            ) : null}
                            <ContentCard actionsFullWidth primaryAction={primaryAction}>
                                <div className="tw-flex tw-h-full tw-flex-col">
                                    <div className="tw-flex tw-flex-col tw-items-center tw-mb-4">
                                        <div className="tw-text-primary"><Heading as="span" variant="title-sm">{plan.key}</Heading></div>
                                        <Heading as="span" variant="display">€{plan.price}/mo</Heading>
                                        <Text tone="muted" variant="caption">{i18next.t('plans.starting_at')}</Text>
                                    </div>
                                    <div className="tw-flex tw-flex-col">
                                        <div>
                                            <div className="tw-mb-2"><Text as="p" variant="body-sm"><strong>{i18next.t('plans.features_label')}:</strong></Text></div>
                                            <FeatureList features={addSpacersToFeatures(plan.features, plans)} iconTone="secondary"/>
                                        </div>
                                        <div className="tw-border-t tw-border-solid tw-border-border tw-my-3" />
                                        <div>
                                            <ConditionsList conditions={plan.conditions} iconTone="secondary"/>
                                        </div>
                                    </div>
                                    <div className="tw-text-primary"><ExtraSection extra={plan.extra}/></div>
                                </div>
                            </ContentCard>
                        </div>
                    )
                })}
            </CardGroup>

            {!canUpdate && (
                <div className="tw-mt-4 tw-flex tw-justify-end">
                    <Link href="mailto:support@wisemetering.com" text={i18next.t('plans.custom_requirements_contact')} variant="control"/>
                </div>
            )}
        </>
    )
}
